module.exports = __webpack_public_path__ + "title_2.7728d3cc.png";